/**
 * Detection Strategy Interface
 * Each strategy is a fully autonomous module responsible for:
 * - Registering its own event listeners
 * - Managing its own state and events
 * - Responding to lifecycle events (start/stop)
 * - Optionally receiving tick updates for polling-based detection
 */
/**
 * Base class for detection strategies
 * Handles event callback pattern to avoid repetition
 */
export class BaseStrategy {
    constructor() {
        this.eventCallback = null;
    }
    setEventCallback(callback) {
        this.eventCallback = callback;
    }
    notifyEvent(weight) {
        if (this.eventCallback) {
            this.eventCallback({
                strategy: this.name,
                weight,
                timestamp: Date.now()
            });
        }
    }
}
